export const addServiceChatBookingQuery = `
mutation AddServiceChatBooking($input: CreateServiceChatBookingInput!) {
    addServiceChatBooking(input: $input) {
        status
        createdAt
    }
}
`;
